module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Carousel"
  }, [_c('div', {
    ref: "slider",
    staticClass: "Carousel-slider",
    style: ({
      transform: ("translate3d(" + _vm.moveX + "px, 0, 0)")
    })
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97af71cc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Carousel.vue
// module id = 289
// module chunks = 1